module.exports = __webpack_public_path__ + "common/tp-featured2-59a200619e5ff63574aa5028844fbf59.svg";